import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Layout = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  // min-width: 1024px;
`;

export const Main = styled(Flex).attrs({
  column: true,
})`
  height: 100%;
  flex: 1 1 calc(100% - 230px);
`;

export const Content = styled(Flex).attrs({
  row: true,
})`
  background: ${props => props.theme.colors.bgGrey};
  width: 100%;
  flex: 1 1 calc(100% - 64px);
  overflow: hidden auto;
`;
